import { render, staticRenderFns } from "./VindicationList.vue?vue&type=template&id=c29cbe24&"
import script from "./VindicationList.vue?vue&type=script&lang=js&"
export * from "./VindicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports